import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from 'src/reducers';

const initialState = {    
    session: {
        loggedIn: localStorage.getItem('loggedIn') === 'true',
        selectedVendorId: localStorage.getItem('selectedVendorId') ? localStorage.getItem('selectedVendorId') : 0,
        token: localStorage.getItem('token') ? JSON.parse(localStorage.getItem('token')) : {},
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {}        
    },
    companyNames: {
        data: localStorage.getItem('companyNames') ? JSON.parse(localStorage.getItem('companyNames')) : []        
    }
    
};

export default function configureStore(preloadedState = initialState) {
    const middlewares = [thunkMiddleware];
    const middlewareEnhancer = composeWithDevTools(
        applyMiddleware(...middlewares)
    );
    const enhancers = [middlewareEnhancer];
    const composedEnhancers = compose(...enhancers);
    return createStore(rootReducer, preloadedState, composedEnhancers);
}
